import React from 'react'
import { Col, Row } from 'react-bootstrap'

// Hooks
import { useState } from '../../../../hooks'

// Components
import ReportFormFilter from '../../Form/Filter'
import ReportTableLaboratoryKPI from '../../Table/LaboratoryKPI'

const ReportContainerLaboratoryKPI = () => {
  const [filter, setFilterState] = useState()

  const handleFilterChange = (filter) => {
    setFilterState(filter)
  }

  return (
    <Row>
      <Col className="mb-3">
        {filter ? (
          <ReportTableLaboratoryKPI
            filter={filter}
            onFilterChange={handleFilterChange}
          />
        ) : (
          <ReportFormFilter
            onFilterChange={handleFilterChange}
            name="laboratory_kpi"
          />
        )}
      </Col>
    </Row>
  )
}

export default ReportContainerLaboratoryKPI
